<section class="absence-page">
  <header class="page-header">
    <div><h1>Urlaub & Abwesenheiten</h1>
      </div>
    <button mat-raised-button color="primary" *ngIf="permissions" [disabled]="!permissions.canRequest" (click)="openForm()"
      [attr.title]="permissions.canRequest ? null : permissions.requestBlockedReason">
      <mat-icon>add</mat-icon> Neuer Antrag
    </button>
  </header>

  <!-- Persönlicher Urlaubsgenehmiger -->
  <section class="approver-card" *ngIf="approver" aria-labelledby="approver-heading">
    <div class="approver-head">
      <mat-icon class="approver-icon">verified_user</mat-icon>
      <h2 id="approver-heading">Urlaubsgenehmiger</h2>
      <span class="approver-mode" [class.manual]="approver.isManual">
        {{ approver.isManual ? 'Manuell festgelegt' : 'Automatisch' }}
      </span>
    </div>

    <div class="approver-body">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="approver-select">
        <mat-label>Genehmiger für meine Anträge</mat-label>
        <mat-select [value]="approverSelection" (selectionChange)="changeApprover($event.value)"
          [disabled]="savingApprover" (openedChange)="!$event && (approverSearch = '')">
          <div class="select-search">
            <input class="select-search-input" placeholder="Name oder E-Mail suchen …" [(ngModel)]="approverSearch"
              (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" aria-label="Genehmiger suchen">
          </div>
          <mat-option [value]="automaticApproverValue">
            <span class="option-standard">{{ automaticOptionLabel }}</span>
          </mat-option>
          <mat-option *ngIf="missingManualApprover" [value]="approver.manualApproverId" disabled>
            Nicht mehr verfügbarer Benutzer
          </mat-option>
          <mat-option *ngFor="let candidate of filteredApproverCandidates" [value]="candidate.userId">
            {{ candidate.name }}<span class="option-mail" *ngIf="candidate.email"> · {{ candidate.email }}</span>
            <span class="option-tag" *ngIf="candidate.userId === approver.automaticApproverId">Teamleitung</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-stroked-button *ngIf="approver.isManual" [disabled]="savingApprover" (click)="resetApprover()">
        <mat-icon>restart_alt</mat-icon> Auf Standard zurücksetzen
      </button>
      <mat-spinner diameter="20" *ngIf="savingApprover"></mat-spinner>
    </div>

    <p class="approver-status ok" *ngIf="approver.canRequest && approver.autoApprove">
      <mat-icon>check_circle</mat-icon>
      Als Leitung deines Hauptteams wird dein eigener Urlaub ohne Genehmiger direkt eingetragen. Wählst du einen Genehmiger,
      muss dieser deine Anträge freigeben.
    </p>
    <p class="approver-status ok" *ngIf="approver.canRequest && !approver.autoApprove">
      <mat-icon>forward_to_inbox</mat-icon>
      Neue Anträge gehen an <strong>{{ approver.effectiveApproverName }}</strong>
      <ng-container *ngIf="!approver.isManual"> ({{ approver.automaticDescription }})</ng-container>.
    </p>
    <p class="approver-status warn" *ngIf="!approver.canRequest" role="alert">
      <mat-icon>warning_amber</mat-icon>
      {{ approver.blockedReason }}
    </p>
    <p class="approver-note" *ngIf="approver.isManual && !approver.leadsPrimaryTeam">
      Automatische Vorauswahl laut Teamzuordnung:
      {{ approver.automaticApproverName || 'keine' }} – {{ approver.automaticDescription }}
    </p>
    <p class="approver-note">
      Bereits eingereichte Anträge bleiben beim Genehmiger, an den sie gesendet wurden.
    </p>
  </section>

  <!-- Hauptteam-Auswahl nur bei mehreren Teams -->
  <div class="primary-team" *ngIf="showPrimarySelection">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Mein Hauptteam</mat-label>
      <mat-select [value]="primaryTeamId" (selectionChange)="changePrimaryTeam($event.value)" [disabled]="savingPrimary">
        <mat-option *ngFor="let team of myTeams" [value]="team.teamId">{{ team.teamName }}</mat-option>
      </mat-select>
    </mat-form-field>
    <span class="primary-hint" *ngIf="primaryTeamId !== null">{{ primaryLeaderHint }}</span>
    <span class="primary-hint warn" *ngIf="primaryTeamId === null">
      Du gehörst mehreren Teams an. Bitte wähle ein Hauptteam – es bestimmt die automatische Vorauswahl deines Urlaubsgenehmigers.
    </span>
  </div>
  <div class="tabs">
    <button type="button" [class.active]="tab === 'calendar'" (click)="setTab('calendar')">Kalender</button>
    <button type="button" [class.active]="tab === 'mine'" (click)="setTab('mine')">Meine Anträge</button>
    <button type="button" *ngIf="isApprover" [class.active]="tab === 'approvals'"
      (click)="setTab('approvals')">Genehmigungen <span class="count" *ngIf="pending.length">{{pending.length}}</span></button>
  </div>

  <div *ngIf="error" class="error">{{error}} <button mat-button (click)="reload()">Erneut versuchen</button></div>
  <div *ngIf="loading" class="loading"><mat-spinner diameter="28"></mat-spinner> Daten werden geladen ...</div>

  <ng-container *ngIf="tab === 'calendar'">
    <div class="toolbar">
      <div class="month-nav">
        <button mat-icon-button aria-label="Vorheriger Monat" (click)="changeMonth(-1)"><mat-icon>chevron_left</mat-icon></button>
        <h2>{{monthLabel}}</h2>
        <button mat-icon-button aria-label="Nächster Monat" (click)="changeMonth(1)"><mat-icon>chevron_right</mat-icon></button>
        <button mat-stroked-button (click)="goToday()">Heute</button>
      </div>
      
    </div>
    <!-- Zeitraumauswahl: ein pointerdown-Handler am Raster, die Zelle liefert data-date.
         pointermove/pointerup werden auf Dokumentebene in der Komponente behandelt. -->
    <div class="calendar" [class.selecting]="selecting" (pointerdown)="onCalendarPointerDown($event)">
      <div class="weekday" *ngFor="let weekday of ['Mo','Di','Mi','Do','Fr','Sa','So']">{{weekday}}</div>
      <div class="day" *ngFor="let day of calendarDays; trackBy: trackDay" [attr.data-date]="day.date"
        [class.outside]="!day.currentMonth"
        [class.selectable]="canSelect" [class.selected]="isSelected(day.date)">
        <span class="day-number">{{day.day}}</span>
        <div class="day-items">
          <div *ngFor="let item of absencesOn(day.date) | slice:0:3" class="absence-pill"
            [style.border-left-color]="item.color || '#7b1fa2'"
            [title]="employeeName(item.userId) + ' – ' + absenceLabel(item)">
            {{absenceLabel(item)}}
          </div>
          <small *ngIf="absencesOn(day.date).length > 3">+{{absencesOn(day.date).length - 3}} weitere</small>
        </div>
      </div>
    </div>
    <p class="hint">Klicke auf einen Tag oder ziehe mit gedrückter Maustaste über mehrere Tage, um einen Antrag zu stellen. Im Kalender erscheinen ausschließlich genehmigte Abwesenheiten. Anträge mit offenem Status findest du unter „Meine Anträge“.</p>
  </ng-container>

  <ng-container *ngIf="tab === 'mine'">
    <div class="stats">
      <div><strong>{{pendingCount}}</strong><span>Offen</span></div>
      <div><strong>{{approvedCount}}</strong><span>Genehmigt</span></div>
      <div><strong>{{rejectedCount}}</strong><span>Abgelehnt</span></div>
    </div>
    <div class="toolbar">
      <h2>Meine Anträge</h2>
      <mat-form-field appearance="outline" class="status-select">
        <mat-label>Status</mat-label>
        <mat-select [(value)]="statusFilter">
          <mat-option value="All">Alle</mat-option>
          <mat-option value="Pending">Offen</mat-option>
          <mat-option value="Approved">Genehmigt</mat-option>
          <mat-option value="Rejected">Abgelehnt</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="empty" *ngIf="!filteredMine.length && !loading">Keine Anträge vorhanden.</div>
    <div class="request-row" *ngFor="let item of filteredMine">
      <div class="request-main">
        <strong>{{item.title || item.categoryName || 'Abwesenheit'}}</strong>
        <span>{{formatRange(item.start, item.end)}} · {{item.categoryName || 'Ohne Kategorie'}}</span>
        <small *ngIf="item.notes">{{item.notes}}</small>
        <small class="approver-line" *ngIf="approverLabel(item)">{{ approverLabel(item) }}</small>
      </div>
      <span class="status" [class.pending]="item.approvalStatus === 'Pending'"
        [class.approved]="item.approvalStatus === 'Approved'"
        [class.rejected]="item.approvalStatus === 'Rejected'">{{statusLabel(item.approvalStatus)}}</span>
      <button mat-stroked-button color="warn" *ngIf="item.canCancel"
        [disabled]="saving" (click)="cancelRequest(item)">Zurückziehen</button>
    </div>
  </ng-container>

  <ng-container *ngIf="tab === 'approvals' && isApprover">
    <div class="toolbar"><h2>Offene Genehmigungen</h2><button mat-stroked-button (click)="reload()" [disabled]="loading || saving"><mat-icon>refresh</mat-icon> Aktualisieren</button></div>
    <div class="empty" *ngIf="!pending.length && !loading">Aktuell sind keine offenen Anträge vorhanden.</div>
    <div class="request-row" *ngFor="let item of pending">
      <div class="request-main">
        <strong>{{item.userName}}</strong>
        <span>{{item.title || item.categoryName || 'Abwesenheit'}} · {{formatRange(item.start, item.end)}}</span>
        <small *ngIf="item.notes">{{item.notes}}</small>
      </div>
      <div class="actions">
        <button mat-stroked-button color="warn" [disabled]="saving || !item.canDecide" (click)="decide(item, false)">Ablehnen</button>
        <button mat-raised-button color="primary" [disabled]="saving || !item.canDecide" (click)="decide(item, true)">Genehmigen</button>
      </div>
    </div>
    <h2>Alle Anträge</h2>
    <div class="empty" *ngIf="!allRequests.length && !loading">Keine Anträge vorhanden.</div>
    <div class="request-row" *ngFor="let item of allRequests">
      <div class="request-main">
        <strong>{{item.userName}}</strong>
        <span>{{item.title || item.categoryName || 'Abwesenheit'}} · {{formatRange(item.start, item.end)}}</span>
      </div>
      <span class="status" [class.pending]="item.approvalStatus === 'Pending'"
        [class.approved]="item.approvalStatus === 'Approved'"
        [class.rejected]="item.approvalStatus === 'Rejected'">{{statusLabel(item.approvalStatus)}}</span>
    </div>
  </ng-container>

  <div class="dialog-backdrop" *ngIf="showForm" (click)="!saving && (showForm = false)">
    <div class="dialog" (click)="$event.stopPropagation()">
      <div class="dialog-heading"><h2>{{ permissions?.autoApprove ? 'Abwesenheit eintragen' : 'Abwesenheit beantragen' }}</h2><button mat-icon-button [disabled]="saving" (click)="showForm = false"><mat-icon>close</mat-icon></button></div>
      <mat-form-field appearance="outline">
        <mat-label>Kategorie</mat-label>
        <mat-select [(ngModel)]="form.categoryId" [disabled]="saving">
          <mat-option *ngFor="let category of categories" [value]="category.id">{{category.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline"><mat-label>Bezeichnung (optional)</mat-label><input matInput [(ngModel)]="form.title" [disabled]="saving"></mat-form-field>
      <div class="date-fields">
        <label>Von <input type="date" [(ngModel)]="form.start" [disabled]="saving"></label>
        <label>Bis <input type="date" [(ngModel)]="form.end" [disabled]="saving"></label>
      </div>
      <mat-form-field appearance="outline"><mat-label>Anmerkung (optional)</mat-label><textarea matInput rows="3" [(ngModel)]="form.notes" [disabled]="saving"></textarea></mat-form-field>
      <p class="dialog-approver" *ngIf="permissions">
        <mat-icon>{{ permissions.autoApprove ? 'check_circle' : 'forward_to_inbox' }}</mat-icon>
        <ng-container *ngIf="permissions.autoApprove">Wird ohne Genehmigung direkt eingetragen.</ng-container>
        <ng-container *ngIf="!permissions.autoApprove">Genehmiger: <strong>{{ permissions.effectiveApproverName }}</strong></ng-container>
      </p>
      <div class="dialog-actions">
        <button mat-button [disabled]="saving" (click)="showForm = false">Abbrechen</button>
        <button mat-raised-button color="primary" [disabled]="saving || !form.start || !form.end || form.categoryId === null" (click)="submit()">{{ permissions?.autoApprove ? 'Direkt eintragen' : 'Antrag senden' }}</button>
      </div>
    </div>
  </div>
</section>
